import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getReferralLinkData, updateClickStats } from '../services/referralService';

const ReferralRedirect: React.FC = () => {
  const { shortCode } = useParams<{ shortCode: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const handleRedirect = async () => {
      console.log('🔍 ReferralRedirect: Starting redirect for shortCode:', shortCode);
      
      if (!shortCode) {
        console.log('❌ No shortCode, redirecting to login');
        navigate('/login');
        return;
      }

      try {
        // Get link data from database
        console.log('📡 Fetching link data for shortCode:', shortCode);
        const linkData = await getReferralLinkData(shortCode);
        console.log('📊 Link data received:', linkData);
        
        if (linkData && linkData.isActive) {
          console.log('✅ Link is active, updating click stats');
          // Update click statistics
          await updateClickStats(shortCode);
          
          // Check if the original URL is from the same origin
          const originalUrl = new URL(linkData.originalUrl);
          const currentOrigin = window.location.origin;
          
          console.log('🌐 Original URL:', linkData.originalUrl);
          console.log('🏠 Current origin:', currentOrigin);
          console.log('🔗 Original URL origin:', originalUrl.origin);
          
          if (originalUrl.origin === currentOrigin) {
            // Same origin - use React Router navigation
            const redirectPath = originalUrl.pathname + originalUrl.search;
            console.log('🚀 Same origin, navigating to:', redirectPath);
            navigate(redirectPath);
          } else {
            // Different origin - use window.location for full redirect
            console.log('🌍 Different origin, using window.location.href');
            window.location.href = linkData.originalUrl;
          }
        } else {
          // Link doesn't exist or is inactive, redirect to login
          console.log('❌ Link not found or inactive, redirecting to login');
          navigate('/login');
        }
      } catch (error) {
        console.error('💥 Redirect error:', error);
        navigate('/login');
      }
    };

    handleRedirect();
  }, [shortCode, navigate]);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        gap: 2
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body1" color="text.secondary">
        Redirecting...
      </Typography>
    </Box>
  );
};

export default ReferralRedirect;
